import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../../translations/lang/en-US.json';

export default class ItemImage extends Component {
  componentDidUpdate() {
    this.switchModal = this.switchModal.bind(this);
  }

  switchModal() {
    this.props.switchModal();
  }

  getOutOfStockLabel(status) {
    return status ? (
      <div className="sold-out-content">
        <div className="sold-out">
          <FormattedMessage id="soldOut" defaultMessage={defaultMsg.soldOut} />
        </div>
      </div>
    ) : null;
  }

  render() {
    const divStyle = {
      backgroundImage: 'url("' + this.props.imageLink + '")',
      margin: 'auto',
    };

    return this.props.imagePresent === 'N' || !this.props.imageLink? (
      this.getOutOfStockLabel(this.props.outOfStock)
    ) : (
      <div className="itemImage">
        {this.props.isPopUp ? (
          <div className='text-center'>
            <img
              className="itemImageImg stock-danger"
              src={this.props.imageLink}
              style={{ margin: 'auto' }}
              alt={this.props.imageName}
            />
            {this.getOutOfStockLabel(this.props.outOfStock)}
          </div>
        ) : (
          <div style={divStyle} className="itemImageImg stock-danger">
            {this.getOutOfStockLabel(this.props.outOfStock)}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/ItemImage.jsx